export enum DynamicFormElementTemplateType {
  CARD = 'CARD',
  EXPANSION_PANEL = 'EXPANSION_PANEL',
  PLAIN = 'PLAIN',
}
